// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1b5V5","colCheckbox":"styles_colCheckbox__YiPNI"};